import { map } from 'nanostores';
import type { BulkPresenceMap } from '../types/presence';

/** Extension -> presence state ('available', 'busy', etc.) */
export const $presenceMap = map<BulkPresenceMap>({});

export function updatePresence(extension: string, state: string): void {
    $presenceMap.setKey(extension, state);
}

export function updatePresenceBulk(data: BulkPresenceMap): void {
    $presenceMap.set(data);
}
